import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "preguntas" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between w-full border-l-[10px] border-primary-400 mt-8 mb-8 text-2xl text-left font-extrabold pt-2 pb-2 pl-4" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Panel de instrucciones")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InquiriesBar = _resolveComponent("InquiriesBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_InquiriesBar)
  ]))
}